import { Link } from "react-router-dom";
import { Box } from "@mui/system";
import PageRoutes from "../Config/PageRoutes";
import LaunchIcon from "@mui/icons-material/Launch";

const ScientificReport = () => {

  return (
    <Box className="scientificReport">
      {/* <Link to={PageRoutes.IMPORTANT_CONCEPTS}>

			</Link> */}
      <Box className="menuItem">
        <a
          target="_blank"
          href="https://efsa.onlinelibrary.wiley.com/doi/full/10.2903/j.efsa.2025.9398"
          rel="noreferrer"
        >
          <p>Access the scientific report</p>
          <LaunchIcon
            fontSize="small"
            style={{ width: "17px", height: "17px", marginLeft: "5px" }}
          />{" "}
        </a>
      </Box>
    </Box>
  );
};

export default ScientificReport;
